<template>
  <v-form v-model="valid" ref="form" lazy-validation @submit.prevent.stop="submit">
    <!-- <v-btn @click="loginWithGoogle">Sign in with Google</v-btn> -->
    <v-text-field
      autofocus
      label="E-mail"
      v-model="email"
      :rules="emailRules"
      validate-on-blur
      required
    ></v-text-field>
    <v-text-field
      v-if="formType == 'newUser'"
      autofocus
      label="Name"
      v-model="name"
      validate-on-blur
      :rules="nameRules"
      required
    ></v-text-field>
    <v-text-field
      v-if="formType != null"
      label="Password"
      :autofocus="formType != 'newUser'"
      v-model="password"
      :rules="passwordRules"
      validate-on-blur
      :append-icon="!e1 ? 'visibility' : 'visibility_off'"
      @click:append="() => (e1 = !e1)"
      :type="e1 ? 'password' : 'text'"
      @keypress.enter="submit"
    ></v-text-field>
    <v-alert type="error" v-model="error" dismissible>{{ errorMsg }}</v-alert>
    <v-btn v-if="formType == null" @click="submit"> Continue </v-btn>
    <v-btn v-else-if="formType == 'newUser'" @click="submit"> Create account </v-btn>
    <v-btn v-else-if="formType == 'existingUser'" @click="submit"> Sign In </v-btn>
    <v-btn text @click="$emit('cancel')"> Cancel </v-btn>
  </v-form>
</template>

<script>
//  Updated
import { checkIfUser } from '@/store/useInvites';
import { createAccountPassword, signInPassword } from '@/store/useAuth';

export default {
  props: ['inviteId'],
  setup() {
    return {
      checkIfUser,
      createAccountPassword,
      signInPassword
    };
  },
  data: () => ({
    valid: true,
    formType: null, //  newUser or existingUser
    name: '',
    nameRules: [v => !!v || 'Gotsta have a name!'],
    email: '',
    emailRules: [
      v => !!v || 'Gotsta have an email!',
      v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be an email.'
    ],
    password: '',
    passwordRules: [
      v => !!v || 'You need a password!',
      v => v.length > 5 || 'You need at least six characters'
    ],
    errorMsg: false,
    e1: true
  }),
  computed: {
    error: {
      get() {
        return !!this.errorMsg;
      },
      set() {
        this.errorMsg = false;
      }
    }
  },
  methods: {
    submit() {
      if (this.formType == null) {
        this.checkEmail();
      } else if (this.formType == 'existingUser') {
        this.signIn();
      } else if (this.formType == 'newUser') {
        this.register();
      }
    },
    async checkEmail() {
      console.log(this.email);
      try {
        const status = await this.checkIfUser(this.email);
        console.log(status);
        if (status.password || !status.google) {
          this.formType = status.password ? 'existingUser' : 'newUser';
        } else {
          console.log('google account only');
          alert('Looks like  you previously used your Google account to sign up. Please try that.');
        }
      } catch (e) {
        console.log(e);
      }
    },
    register() {
      console.log('register!');
      this.$emit('signInStart');
      const { name, email, password, inviteId } = this;
      this.createAccountPassword({ name, email, password, inviteId }).then(
        () => {
          this.$emit('close');
        },
        err => {
          console.log(`oops: ${err.message}`);
          this.errorMsg = err.message;
        }
      );
    },
    signIn() {
      const { email, password } = this;
      this.$emit('signInStart');
      this.signInPassword({ email, password })
        .then(() => {
          console.log('sign in success');
          this.$emit('signInSuccess');
        })
        .catch(e => {
          console.log(e);
          if (e.code == 'auth/wrong-password') {
            this.errorMsg = "Dang. Wrong password. Maybe it's your other one?";
          }
          this.$emit('signInError', e);
        });
    }
  }
};
</script>
